


































































































































































































































import mixins from 'vue-typed-mixins';
import SurveyUtils, {
  Survey,
  SurveyGroup,
  SurveyState,
} from '@/utils/SurveyUtils';
import moment from 'moment';
import ResourceUtils, { Bookshelf } from '@/utils/ResourceUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Survey,
    },
  },
  computed: {
    states() {
      return [
        'inactive',
        'active_no_submission',
        'active_allow_submission',
        'closed',
        'archived',
      ];
    },
    defaultStateOptions(): any {
      return this.surveyStates?.map((state) => ({
        text: state.key,
        value: state,
      }));
    },
    surveyGroupOptions(): any {
      return this.surveyGroups?.map((group) => ({
        text: group.name,
        value: group,
      }));
    },
    bookshelfOptions(): any {
      return this.bookshelves?.map((bookshelf) => ({
        text: this.$translate(bookshelf.name),
        value: bookshelf,
      }));
    },
  },
  data(): {
    surveyGroups?: SurveyGroup[];
    surveyStates?: SurveyState[];
    bookshelves?: Bookshelf[];
  } {
    return {
      surveyGroups: undefined,
      surveyStates: undefined,
      bookshelves: undefined,
    };
  },
  async mounted() {
    try {
      const resp = await Promise.all([
        SurveyUtils.api.surveyGroup.list(),
        SurveyUtils.api.surveyState.list({
          surveyid: this.value.id as number,
        }),
        ResourceUtils.api.bookshelf.list(),
      ]);
      this.surveyGroups = resp[0];
      this.surveyStates = resp[1];
      this.bookshelves = resp[2];

      if (this.value.surveygroup) {
        this.value.surveygroup = this.surveyGroups.find(
          (group) => group.id === this.value.surveygroup.id
        ) as SurveyGroup;
        this.$emit('pristine', { surveygroup: this.value.surveygroup });
      }

      if (this.value.defaultstate) {
        this.value.defaultstate = this.surveyStates.find(
          (state) => state.id === this.value.defaultstate?.id
        );
        this.$emit('pristine', { defaultstate: this.value.defaultstate });
      }

      if (this.value.bookshelf) {
        this.value.bookshelf = this.bookshelves.find(
          (bookshelf) => bookshelf.id === this.value.bookshelf?.id
        );
        this.$emit('pristine', { bookshelf: this.value.bookshelf });
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
});
